import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "multiple-logins",
  "use": "multiple-logins-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"multiple-logins\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.5 6a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm6 0a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zM11 7.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\" /><path d=\"M9.5 14c.5 0 .5-.5.5-.5V13s0-4-4-4H4c-4 0-4 4-4 4v.5s0 .5.5.5h9zm5.5-.5V13s0-3-3-3h-2c-1 0-1-.96-1-1h3c4 0 4 4 4 4v.5s0 .5-.5.5-.5-.5-.5-.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol